export default __webpack_public_path__ + "static/media/MySQL.de48f3e1.png";